interface ColorSwatchProps {
  name: string;
  hex: string;
  description: string;
}

export function ColorSwatch({ name, hex, description }: ColorSwatchProps) {
  return (
    <div className="flex flex-col">
      <div
        className="h-32 w-full mb-4 border border-[#293129]/10 rounded-sm"
        style={{ backgroundColor: hex }}
      />
      <p className="font-serif text-xl mb-1">{name}</p>
      <p className="text-[10px] tracking-widest uppercase font-bold mb-2 opacity-50">{hex}</p>
      <p className="text-[10px] tracking-[0.2em] uppercase opacity-70 leading-relaxed">
        {description}
      </p>
    </div>
  );
}
